export const colors = {
  white: '#FFF',
  headerBg: '#D2F5FF',
  brightGreen: '#13E800',
};
